// Helpers puros para mostrar los archivos de la carga de documentos (tamaño,
// tipo y fecha) sin depender de pipes ni del LOCALE_ID del módulo.

// Formatos que acepta el app-backend (validateFile en
// app/validations/document.validation.js): si se amplía allá, se amplía aquí
// para que el aviso salga antes de subir.
export const TIPOS_DOCUMENTO_ACEPTADOS = ['image/png', 'image/jpg', 'image/jpeg', 'application/pdf']
export const FORMATOS_DOCUMENTO_TEXTO = 'JPG, PNG o PDF'

export type TipoDocumento = 'imagen' | 'pdf' | 'otro'

interface IArchivoLike {
  name?: string | null
  type?: string | null
}

// Sirve igual para un File que para la URL de un archivo ya guardado.
export const tipoDeArchivo = (archivo: IArchivoLike | null | undefined): TipoDocumento => {
  const tipo = (archivo?.type ?? '').toLowerCase()
  if (tipo === 'application/pdf') return 'pdf'
  if (tipo.startsWith('image/')) return 'imagen'
  const nombre = (archivo?.name ?? '').toLowerCase().split(/[?#]/)[0]
  if (nombre.endsWith('.pdf')) return 'pdf'
  if (/\.(png|jpe?g|webp|gif|heic|heif)$/.test(nombre)) return 'imagen'
  return 'otro'
}

export const esImagen = (archivo: IArchivoLike | null | undefined): boolean => tipoDeArchivo(archivo) === 'imagen'

export const esPdf = (archivo: IArchivoLike | null | undefined): boolean => tipoDeArchivo(archivo) === 'pdf'

// Algunos selectores de Android no informan el tipo: entonces decide la extensión
// (y si de verdad no es válido, el backend lo rechaza con su mensaje).
export const tipoAceptado = (archivo: IArchivoLike | null | undefined): boolean => {
  const tipo = (archivo?.type ?? '').toLowerCase()
  if (tipo) return TIPOS_DOCUMENTO_ACEPTADOS.includes(tipo)
  return /\.(png|jpe?g|pdf)$/i.test(archivo?.name ?? '')
}

// Unidades decimales, como el tope del backend (20 MB = 20,000,000 bytes).
export const formatoTamano = (bytes: number | null | undefined): string => {
  const n = Math.max(0, Math.round(Number(bytes) || 0))
  if (n < 1000) return `${n} B`
  const kb = Math.round(n / 1000)
  if (kb < 1000) return `${kb} KB`
  const mb = Math.round(n / 100000) / 10
  return `${Number.isInteger(mb) ? mb.toFixed(0) : mb.toFixed(1)} MB`
}

let formatoFecha: Intl.DateTimeFormat | null = null
const formateador = (): Intl.DateTimeFormat => {
  if (formatoFecha) return formatoFecha
  try {
    // El día de México, no el del teléfono o el servidor.
    formatoFecha = new Intl.DateTimeFormat('es-MX', {day: 'numeric', month: 'short', year: 'numeric', timeZone: 'America/Mexico_City'})
  } catch {
    formatoFecha = new Intl.DateTimeFormat('es-MX', {day: 'numeric', month: 'short', year: 'numeric'})
  }
  return formatoFecha
}

// «1 oct 2026». Vacío si no hay fecha o no se puede leer.
export const formatoFechaSubida = (fecha: Date | string | null | undefined): string => {
  if (!fecha) return ''
  const d = fecha instanceof Date ? fecha : new Date(fecha)
  if (isNaN(d.getTime())) return ''
  return formateador().format(d).replace(/\./g, '')
}
